__turbopack_context__.v({
  "body": "index-module-scss-module__ms6d8W__body",
  "buttonBack": "index-module-scss-module__ms6d8W__buttonBack",
  "buttonBack_active": "index-module-scss-module__ms6d8W__buttonBack_active",
  "modeButton": "index-module-scss-module__ms6d8W__modeButton",
  "modeButton_active": "index-module-scss-module__ms6d8W__modeButton_active",
  "modeWrapper": "index-module-scss-module__ms6d8W__modeWrapper",
});
